module.exports = [
  { id: 'yes', name: 'Yes' },
  { id: 'no', name: 'No' }
]
